"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGE_ADDRESS = exports.LAYERZERO_APPS_PUBKEY = exports.EXECUTOR_EXT_ADDRESS = exports.EXECUTOR_ADDRESS = exports.RELAYER_SIGNER_ADDRESS = exports.ORACLE_SIGNER_ADDRESS = exports.ORACLE_ADDRESS = exports.LAYERZERO_APPS_ADDRESS = exports.LAYERZERO_ADDRESS = exports.FAUCET_URL = exports.NODE_URL = void 0;
const lz_sdk_1 = require("@layerzerolabs/lz-sdk");
const types_1 = require("./types");
exports.NODE_URL = {
    [types_1.Environment.MAINNET]: 'https://mainnet.aptoslabs.com/v1',
    [types_1.Environment.TESTNET]: 'https://fullnode.testnet.aptoslabs.com/v1',
    [types_1.Environment.DEVNET]: 'https://fullnode.devnet.aptoslabs.com/v1',
    [types_1.Environment.LOCAL]: 'http://127.0.0.1:8080/v1', // 'http://192.168.0.169:8080/v1
};
exports.FAUCET_URL = {
    [types_1.Environment.MAINNET]: '',
    [types_1.Environment.TESTNET]: 'https://faucet.testnet.aptoslabs.com',
    [types_1.Environment.DEVNET]: 'https://faucet.devnet.aptoslabs.com',
    [types_1.Environment.LOCAL]: 'http://127.0.0.1:8081', // 'http://192.168.0.169:8081
};
exports.LAYERZERO_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90',
    [lz_sdk_1.ChainStage.TESTNET]: '0x1759cc0d3161f1eb79f65847d4feb9d1f74fb79014698a23b16b28b9cd4c37e3',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0xcdc2c5597e2a96faf08135db560e3846e8c8c5683b0db868f6ad68f143906b3e',
};
exports.LAYERZERO_APPS_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0x43d8cad89263e6936921a0adb8d5d49f0e236c229460f01b14dca073114df2b9',
    [lz_sdk_1.ChainStage.TESTNET]: '0x2f972c173927006c83277b6e6ae38f83482eba560f343d022f145979020d3621',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0x43d8cad89263e6936921a0adb8d5d49f0e236c229460f01b14dca073114df2b9',
};
exports.ORACLE_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0xc2846ea05319c339b3b52186ceae40b43d4e9cf6c7350336c3eb0b351d9394eb',
    [lz_sdk_1.ChainStage.TESTNET]: '0x8ab85d94bf34808386b3ce0f9516db74d2b6d2f1166aa48f75ca641f3adb6c63',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0x38ee7e8bc9d2601ec0934a5d6e23182a266380d87840e5f0850bfeb647297d3a',
};
exports.ORACLE_SIGNER_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0x12e12de0af996d9611b0b78928cd9f4cbf50d94d972043cdd829baa77a78929b',
    [lz_sdk_1.ChainStage.TESTNET]: '0x47a30bcdb5b5bdbf6af883c7325827f3e40b3f52c3538e9e677e68cf0c0db060',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0x760b1ad2811b7c3e7e04a9dc38520320dc30850fbf001db61c18d1e36221d5c8',
};
exports.RELAYER_SIGNER_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0x1d8727df513fa2a8785d0834e40b34223daff1affc079574082baadb74b66ee4',
    [lz_sdk_1.ChainStage.TESTNET]: '0xc192864c4215741051321d44f89c3b7a54840a0b1b7ef5bec6149a07f9df4641',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0xc180500ddac3fef70cb1e9fc0d75793850e2cef84d518ea0a3b3adfb93751ea7',
};
exports.EXECUTOR_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0x1d8727df513fa2a8785d0834e40b34223daff1affc079574082baadb74b66ee4',
    [lz_sdk_1.ChainStage.TESTNET]: '0xc192864c4215741051321d44f89c3b7a54840a0b1b7ef5bec6149a07f9df4641',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0xc180500ddac3fef70cb1e9fc0d75793850e2cef84d518ea0a3b3adfb93751ea7',
};
exports.EXECUTOR_EXT_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0xd122ac52d43736e0f524a334fc37b6750884559da7ddf1aee0b11b6ae62643d7',
    [lz_sdk_1.ChainStage.TESTNET]: '0x39942f4bd78e899f162644b5ec5998a19cb6de1ff8b7321070cb75cf96e5cf6c',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '',
};
// LAYERZERO_APPS_PUBKEY will be used to call simulateTransaction
exports.LAYERZERO_APPS_PUBKEY = {
    [lz_sdk_1.ChainStage.MAINNET]: '0xf57e5a95ae0e2b5f999ac14abd0ff73daf64e6e7e2a1fad024f2e44422e88d76',
    [lz_sdk_1.ChainStage.TESTNET]: '0xa6d39a1f522da0298a387032952393b1dd2f88ea75423de05c26792930c60ac0',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0xf57e5a95ae0e2b5f999ac14abd0ff73daf64e6e7e2a1fad024f2e44422e88d76',
};
exports.BRIDGE_ADDRESS = {
    [lz_sdk_1.ChainStage.MAINNET]: '0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa',
    [lz_sdk_1.ChainStage.TESTNET]: '0xec84c05cc40950c86d8a8bed19552f1e8ebb783196bb021c916161d22dc179f7',
    [lz_sdk_1.ChainStage.TESTNET_SANDBOX]: '0x808b4ffe04011cd20327a910518b4bff661f73fa907e9fc41ad690f84fa6f83e',
};
